import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import useStyles from './styles';
import PBI_SRC from '../../common/constants/PowerbiSourceUrl';
import { setDrawerOpened } from '../HomePage/ContentTabs/ContentTabsSlice';

export default function TotalCostOfOwnershipPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClickAway = () => {
    dispatch(setDrawerOpened(false));
  };

  return (
    <div className={classes.root}>
      <Grid>
        <Typography className={classes.title}> {t('total cost')}</Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <div className={classes.description}>
            {t('total cost description')}
          </div>
          <div className={classes.iframe} data-testid="total-cost-chart">
            <iframe
              onLoad={handleClickAway}
              title="total cost"
              width="100%"
              height="550px"
              src={PBI_SRC.totalCostOfOwnership}
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </Paper>
      </Grid>
    </div>
  );
}
